// extracted by mini-css-extract-plugin
export default {"empty-icon-spacer":"IFyDRL"};